











import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import GeoLocation from "./GeoLocation.vue";

@Component({ components: { GeoLocation } })
export default class Scaffold extends Vue {
  locations = {
    centroid: [-15.998024333333333, 48.96501216666667],
    locations: [
      {
        name: "Diana, Antsiranana Province, Madagascar",
        type: "Origin",
        moved: false,
        latlng: [-13.108811, 49.138901],
        accuracy: "Point",
      },
      {
        name: "Sava, Antsiranana Province, Madagascar",
        type: "Origin",
        moved: false,
        latlng: [-14.293872, 49.773403],
        accuracy: "Point",
      },
      {
        name: "Sofia, Province de Mahajanga, Madagascar",
        type: "Origin",
        moved: false,
        latlng: [-15.281594, 48.172066],
        accuracy: "Point",
      },
      {
        name: "Analanjirofo, Toamasina Province, Madagascar",
        type: "Origin",
        moved: false,
        latlng: [-16.316196, 49.491779],
        accuracy: "Point",
      },
      {
        name: "Atsinanana, Toamasina Province, Madagascar",
        type: "Origin",
        moved: false,
        latlng: [-18.976799, 48.862484],
        accuracy: "Point",
      },
      {
        name: "Alaotra-Mangoro, Toamasina Province, Madagascar",
        type: "Origin",
        moved: false,
        latlng: [-18.010874, 48.35144],
        accuracy: "Point",
      },
    ],
  };

  debug() {
    console.log("debug");
  }
}
